import {
	AppstoreFilled,
	BugFilled,
	CalendarOutlined,
	FileTextFilled,
	MoreOutlined,
	SearchOutlined,
	UserAddOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ROUTES } from '../../const/routes';
import { useUserFeatureFlags } from '../../hooks/useUserFeatureFlags';
import { useDeviceStore } from '../../stores/DeviceStore';

const MobileMenuStyled = styled.div`
	background-color: #fff;

	grid-area: footer;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	border-top: 1px solid #f0f0f0;
`;

const MenuItemRoot = styled.span<{ $active: boolean; $primary?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	width: 25%;
	height: 100%;

	color: ${({ $active }) => ($active ? '#2875EA' : '#BFBFBF')};

	&:hover {
		cursor: pointer;
	}
`;

const IconWrapper = styled.span<{ $primary?: boolean }>`
	font-size: 20px;
	padding-bottom: 0.5em;
`;

const TextWrapper = styled.span<{ $isPrimary?: boolean }>`
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	padding-top: ${({ $isPrimary }) => ($isPrimary ? '10px' : '0px')};
`;

const MobileMenu: React.FC = () => {
	const isNavigationOpened = useDeviceStore(state => state.isNavigationOpened);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const featureFlags = useUserFeatureFlags();

	const isActive = (buttonPath: string) => {
		if (pathname === '/app') {
			return pathname === buttonPath;
		}
		if (buttonPath === '/app') {
			return false;
		}
		return pathname.startsWith(buttonPath);
	};

	if (!isNavigationOpened) {
		return null;
	}

	const menuItems = [];

	menuItems.push({ name: 'Přehled', path: ROUTES.APP.ROOT, icon: <AppstoreFilled /> });

	menuItems.push({ name: 'Kalendář', path: ROUTES.APP.CALENDAR, icon: <CalendarOutlined /> });

	menuItems.push({ name: 'Vyhledat', path: ROUTES.APP.SEARCH, icon: <SearchOutlined />, primary: false });

	menuItems.push({ name: 'Zkoušky', path: ROUTES.APP.EXAMS, icon: <FileTextFilled /> });

	menuItems.push({ name: 'Více', path: ROUTES.APP.MORE, icon: <MoreOutlined /> });

	if (featureFlags.DEBUG) {
		menuItems.push({ name: 'Debug', path: ROUTES.APP.DEBUG, icon: <BugFilled /> });
	}

	return (
		<MobileMenuStyled>
			{/* <MenuBody> */}
			{menuItems.map(i => (
				<MenuItemRoot
					key={i.name}
					onClick={() => navigate(i.path)}
					$active={isActive(i.path)}
					$primary={i.primary}
				>
					{i.primary ? (
						<>
							<Button
								shape="circle"
								icon={<UserAddOutlined />}
								type={!isActive(i.path) ? undefined : 'primary'}
								size="large"
							/>
							<TextWrapper $isPrimary={i.primary}>{i.name}</TextWrapper>
						</>
					) : (
						<>
							<IconWrapper>{i.icon}</IconWrapper>
							<TextWrapper>{i.name}</TextWrapper>
						</>
					)}
				</MenuItemRoot>
			))}
			{/* </MenuBody> */}
		</MobileMenuStyled>
	);
};

export default MobileMenu;
